(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jamos-about-history"]) return;
  try {
    
  (() => {
    const requestedSection = new URLSearchParams(window.location.search).get('section');
    const historySection = document.getElementById('jamos-about-history');

    if (requestedSection !== 'history' || !historySection) return;

    window.requestAnimationFrame(() => {
      historySection.scrollIntoView({ block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamos-about-page"]) return;
  try {
    
  (() => {
    const sectionMap = {
      history: 'jamos-about-history',
      promise: 'jamos-about-promise',
      team: 'jamos-about-team'
    };
    const targetId = sectionMap[new URLSearchParams(window.location.search).get('section')];
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamos-learn-more"]) return;
  try {
    
  (() => {
    const learnMoreHub = document.querySelector('.jamos-learn-more--hub');
    if (learnMoreHub) {
      const startHubTextReveal = () => learnMoreHub.classList.add('is-hub-loaded');
      if (document.readyState === 'complete') {
        startHubTextReveal();
      } else {
        window.addEventListener('load', startHubTextReveal, { once: true });
      }
    }

    const contactHero = document.querySelector('.jamos-learn-more--contact .jamos-learn-more__hero');
    const orderingShippingHero = document.querySelector('.jamos-learn-more--ordering_shipping .jamos-learn-more__hero');
    const faqHero = document.querySelector('.jamos-learn-more--faqs .jamos-learn-more__hero');
    const fixedHeader = document.querySelector('.jamos-alt-header');

    if (contactHero || orderingShippingHero || faqHero) {
      let framePending = false;
      const updateContactHeroStickyOffset = () => {
        framePending = false;
        const headerHeight = fixedHeader
          ? Array.from(fixedHeader.querySelectorAll(':scope > .jamos-alt-header__notice, :scope > .jamos-alt-header__bar'))
              .reduce((height, element) => height + element.getBoundingClientRect().height, 0)
          : 0;
        contactHero?.style.setProperty('--jamos-contact-hero-sticky-top', `${headerHeight}px`);
        orderingShippingHero?.style.setProperty('--jamos-ordering-shipping-hero-sticky-top', `${headerHeight}px`);
        faqHero?.style.setProperty('--jamos-faqs-hero-sticky-top', `${headerHeight}px`);
      };
      const requestContactHeroStickyOffsetUpdate = () => {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(updateContactHeroStickyOffset);
      };

      updateContactHeroStickyOffset();
      window.addEventListener('scroll', requestContactHeroStickyOffsetUpdate, { passive: true });
      window.addEventListener('resize', requestContactHeroStickyOffsetUpdate);
    }

    const faqItems = Array.from(document.querySelectorAll('.jamos-learn-more--faqs .jamos-learn-more__faq-item'));

    faqItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) {
          item.classList.remove('is-closing');
          window.requestAnimationFrame(() => item.classList.add('is-closing'));
          window.setTimeout(() => item.classList.remove('is-closing'), 620);
          return;
        }

        item.classList.remove('is-closing');
        faqItems.forEach((otherItem) => {
          if (otherItem !== item && otherItem.open) otherItem.open = false;
        });
      });
    });

    // Align the finder with the actual compact header, including its load-time transition.
    const finderAnchor = document.getElementById('find-josefs');
    const finderHeader = document.querySelector('.jamos-alt-header');
    if (finderAnchor && finderHeader) {
      let alignmentFrame = 0;
      let alignmentInterrupted = false;
      const updateFinderOffset = () => {
        const bottom = finderHeader.getBoundingClientRect().bottom;
        finderAnchor.style.setProperty('--jamos-finder-header-height', `${Math.max(0, bottom)}px`);
        return bottom;
      };
      const stopFinderAlignment = () => {
        alignmentInterrupted = true;
        window.cancelAnimationFrame(alignmentFrame);
      };
      const alignFinder = () => {
        if (window.location.hash !== '#find-josefs') return;
        window.cancelAnimationFrame(alignmentFrame);
        alignmentInterrupted = false;
        const deadline = performance.now() + 1200;
        let stableFrames = 0;
        let lastHeaderBottom = -1;
        const align = () => {
          if (alignmentInterrupted) return;
          const headerBottom = updateFinderOffset();
          const delta = finderAnchor.getBoundingClientRect().top - headerBottom;
          if (Math.abs(delta) > .5) window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
          stableFrames = Math.abs(delta) <= .5 && Math.abs(headerBottom - lastHeaderBottom) <= .5 ? stableFrames + 1 : 0;
          lastHeaderBottom = headerBottom;
          if (stableFrames < 4 && performance.now() < deadline) alignmentFrame = window.requestAnimationFrame(align);
        };
        alignmentFrame = window.requestAnimationFrame(align);
      };
      updateFinderOffset();
      if ('ResizeObserver' in window) new ResizeObserver(updateFinderOffset).observe(finderHeader);
      window.addEventListener('hashchange', alignFinder);
      window.addEventListener('load', () => { if (!alignmentInterrupted) alignFinder(); }, { once: true });
      document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const destination = new URL(link.href, window.location.href);
        if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash === '#find-josefs') {
          window.requestAnimationFrame(alignFinder);
        }
      });
      window.addEventListener('wheel', stopFinderAlignment, { passive: true });
      window.addEventListener('touchstart', stopFinderAlignment, { passive: true });
      window.addEventListener('pointerdown', stopFinderAlignment, { passive: true });
      window.addEventListener('keydown', (event) => {
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Tab'].includes(event.key)) stopFinderAlignment();
      });
      alignFinder();
    }

    document.querySelectorAll('[data-jamos-store-locator]').forEach((form) => {
      const locator = form.closest('.jamos-learn-more__contact-locator');
      const input = form.querySelector('input[name="location"]');
      const submit = form.querySelector('[data-jamos-store-locator-submit]');
      const map = locator?.querySelector('[data-jamos-store-locator-map]');
      const status = locator?.querySelector('[data-jamos-store-locator-status]');

      if (!input || !submit || !map || !status) return;

      const updateMap = () => {
        const location = input.value.trim();
        if (!location) {
          status.textContent = form.dataset.emptyMessage || '';
          input.focus();
          return;
        }

        map.src = `https://www.google.com/maps?output=embed&q=${encodeURIComponent(`Wegmans Food Markets near ${location}`)}`;
        status.textContent = `${form.dataset.resultsMessage || ''} ${location}.`;
      };

      submit.addEventListener('click', updateMap);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        updateMap();
      });
    });

    document.querySelectorAll('[data-jamos-guarantee-certificate]').forEach((certificate) => {
      const close = certificate.querySelector('.jamos-learn-more__guarantee-v3-close');
      const open = () => {
        certificate.classList.add('is-expanded');
        certificate.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('jamos-certificate-modal-open');
        close?.focus();
      };
      const dismiss = () => {
        certificate.classList.remove('is-expanded');
        certificate.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('jamos-certificate-modal-open');
        certificate.focus();
      };
      certificate.addEventListener('click', (event) => {
        if (event.target === close) dismiss();
        else if (!certificate.classList.contains('is-expanded')) open();
      });
      certificate.addEventListener('keydown', (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && !certificate.classList.contains('is-expanded')) { event.preventDefault(); open(); }
        if (event.key === 'Escape') dismiss();
      });
    });

    document.querySelectorAll('.jamos-blog-article').forEach((article) => {
      article.querySelectorAll('.jamos-blog-article__module').forEach((module) => {
        const localizedMarkup = module.textContent;
        if (localizedMarkup.includes('<')) module.innerHTML = localizedMarkup;
      });

      const sourceLeadModule = article.querySelector('.jamos-blog-article__module:first-child');
      const sourceLeadImage = sourceLeadModule?.querySelector('figure img');
      const heroImage = article.querySelector('.jamos-blog-article__hero > img');

      if (sourceLeadImage && heroImage) {
        heroImage.src = sourceLeadImage.currentSrc || sourceLeadImage.src;
        heroImage.alt = sourceLeadImage.alt || heroImage.alt;
        sourceLeadModule.classList.add('is-article-hero-source');
      }

      const heroVideo = article.querySelector('.jamos-blog-article__hero-video');
      const videoToggle = article.querySelector('.jamos-blog-article__video-toggle');
      if (heroVideo && videoToggle) {
        const updatePlayback = () => {
          videoToggle.classList.toggle('is-paused', heroVideo.paused);
          videoToggle.setAttribute('aria-label', heroVideo.paused ? videoToggle.dataset.playLabel : videoToggle.dataset.pauseLabel);
        };
        const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (motionPreference.matches) heroVideo.pause();
        motionPreference.addEventListener('change', (event) => { if (event.matches) heroVideo.pause(); });
        heroVideo.addEventListener('play', updatePlayback);
        heroVideo.addEventListener('pause', updatePlayback);
        videoToggle.addEventListener('click', () => {
          if (heroVideo.paused) heroVideo.play().catch(updatePlayback);
          else heroVideo.pause();
        });
        const showFallback = () => { heroVideo.hidden = true; videoToggle.hidden = true; };
        heroVideo.addEventListener('error', showFallback);
        heroVideo.querySelector('source')?.addEventListener('error', showFallback);
        videoToggle.hidden = false;
        updatePlayback();
      }

      if (article.closest('.jamos-learn-more--blog_article_1')) {
        const modules = article.querySelectorAll('.jamos-blog-article__module');
        [[3, 4, 5], [8, 9], [12, 13]].forEach((group) => {
          const [primaryIndex, ...continuationIndexes] = group;
          const primary = modules[primaryIndex - 1];

          continuationIndexes.forEach((continuationIndex) => {
            const continuation = modules[continuationIndex - 1];
            if (!primary || !continuation) return;
            while (continuation.firstChild) primary.appendChild(continuation.firstChild);
            continuation.classList.add('is-source-continuation');
          });
        });

        const productLink = article.querySelector('.jamos-blog-article__product-link');
        const productCopy = modules[11];
        if (productLink && productCopy) productCopy.appendChild(productLink);
      }

      if (article.closest('.jamos-learn-more--blog_article_2')) {
        const modules = article.querySelectorAll('.jamos-blog-article__module');
        [[2, 3, 4], [5, 6], [9, 10], [11, 12, 13], [17, 18]].forEach((group) => {
          const [primaryIndex, ...continuationIndexes] = group;
          const primary = modules[primaryIndex - 1];

          continuationIndexes.forEach((continuationIndex) => {
            const continuation = modules[continuationIndex - 1];
            if (!primary || !continuation) return;
            const primaryList = primary.querySelector(':scope > ul:last-of-type');
            const continuationList = continuation.querySelector(':scope > ul');

            if (primaryList && continuationList) {
              while (continuationList.firstChild) primaryList.appendChild(continuationList.firstChild);
              continuationList.remove();
            }
            while (continuation.firstChild) primary.appendChild(continuation.firstChild);
            continuation.classList.add('is-source-continuation');
          });
        });
      }

      const mergeSourceModules = (modules, indexes) => {
        const [primaryIndex, ...continuationIndexes] = indexes;
        const primary = modules[primaryIndex - 1];
        if (!primary) return null;

        continuationIndexes.forEach((continuationIndex) => {
          const continuation = modules[continuationIndex - 1];
          if (!continuation) return;
          while (continuation.firstChild) primary.appendChild(continuation.firstChild);
          continuation.classList.add('is-source-continuation');
        });

        return primary;
      };

      const makeSourceRow = (modules, indexes, className = '') => {
        const entries = indexes.map((index) => modules[index - 1]).filter(Boolean);
        if (!entries.length) return null;
        const row = document.createElement('div');
        row.className = `jamos-blog-article__source-row ${className}`.trim();
        entries[0].before(row);
        entries.forEach((entry) => row.appendChild(entry));
        return row;
      };

      const makeProductGrid = (modules, groups) => {
        const grid = document.createElement('div');
        grid.className = 'jamos-blog-article__source-product-grid';
        const firstModule = modules[groups[0]?.[0] - 1];
        if (!firstModule) return;
        firstModule.before(grid);

        groups.forEach((group) => {
          const productModules = group.map((index) => modules[index - 1]).filter(Boolean);
          if (!productModules.length) return;
          const product = document.createElement('div');
          product.className = 'jamos-blog-article__source-product';
          grid.appendChild(product);
          const [productImage, ...productDetails] = productModules;
          product.appendChild(productImage);
          const details = document.createElement('div');
          details.className = 'jamos-blog-article__source-product__details';
          product.appendChild(details);
          productDetails.forEach((module) => details.appendChild(module));
        });
        return grid;
      };

      const guideLayout = article.closest('.jamos-learn-more--blog_article_4, .jamos-learn-more--blog_article_5, .jamos-learn-more--blog_article_6');
      if (guideLayout) {
        const modules = article.querySelectorAll('.jamos-blog-article__module');
        const source = article.querySelector('.jamos-blog-article__source');
        source?.classList.add('is-source-layout-guide');
        const articleNumber = guideLayout.className.match(/blog_article_(\d+)/)?.[1];

        if (articleNumber === '4') {
          mergeSourceModules(modules, [3, 4]);
          makeSourceRow(modules, [3, 5]);
          makeSourceRow(modules, [6, 7], 'jamos-blog-article__source-row--reverse jamos-blog-article__source-row--feature');
          makeSourceRow(modules, [8, 9]);
          makeSourceRow(modules, [10, 11], 'jamos-blog-article__source-row--reverse');
          makeSourceRow(modules, [12], 'jamos-blog-article__source-row--callout');
          makeProductGrid(modules, [[13, 14, 15]]);
        }

        if (articleNumber === '5') {
          mergeSourceModules(modules, [3, 4]);
          makeSourceRow(modules, [3, 5]);
          makeSourceRow(modules, [6, 7], 'jamos-blog-article__source-row--reverse jamos-blog-article__source-row--feature');
          mergeSourceModules(modules, [8, 9]);
          makeSourceRow(modules, [8, 10]);
          mergeSourceModules(modules, [12, 13]);
          makeSourceRow(modules, [11, 12], 'jamos-blog-article__source-row--reverse');
          makeSourceRow(modules, [14], 'jamos-blog-article__source-row--callout');
          makeProductGrid(modules, [[15, 16, 17]]);
        }

        if (articleNumber === '6') {
          makeSourceRow(modules, [3, 4]);
          makeSourceRow(modules, [5, 6], 'jamos-blog-article__source-row--reverse jamos-blog-article__source-row--feature');
          mergeSourceModules(modules, [7, 8]);
          makeSourceRow(modules, [7, 9]);
          makeSourceRow(modules, [10, 11], 'jamos-blog-article__source-row--reverse');
          makeSourceRow(modules, [12], 'jamos-blog-article__source-row--callout');
          makeProductGrid(modules, [[13, 14, 15]]);
        }
      }

      const grillerLayout = article.closest('.jamos-learn-more--blog_article_7, .jamos-learn-more--blog_article_8, .jamos-learn-more--blog_article_9');
      if (grillerLayout) {
        const modules = article.querySelectorAll('.jamos-blog-article__module');
        const source = article.querySelector('.jamos-blog-article__source');
        source?.classList.add('is-source-layout-griller');
        const articleNumber = grillerLayout.className.match(/blog_article_(\d+)/)?.[1];

        if (articleNumber === '7') {
          modules[0]?.classList.add('is-source-continuation');
          modules[1]?.classList.add('is-source-continuation');
          makeSourceRow(modules, [3, 4], 'jamos-blog-article__source-row--feature');
          mergeSourceModules(modules, [6, 7, 8]);
          makeSourceRow(modules, [5, 6]);
          mergeSourceModules(modules, [10, 11]);
          makeSourceRow(modules, [9, 10]);
          mergeSourceModules(modules, [12, 13]);
          makeSourceRow(modules, [12, 14], 'jamos-blog-article__source-row--tips');
          makeSourceRow(modules, [15], 'jamos-blog-article__source-row--callout');
          modules[18]?.classList.add('is-source-continuation');
          modules[22]?.classList.add('is-source-continuation');
          makeProductGrid(modules, [[16, 17, 18], [20, 21, 22]]);
          makeSourceRow(modules, [24, 25], 'jamos-blog-article__source-row--bundle');
        }

        if (articleNumber === '8') {
          modules[0]?.classList.add('is-source-continuation');
          makeSourceRow(modules, [3], 'jamos-blog-article__source-row--feature');
          mergeSourceModules(modules, [5, 6]);
          makeSourceRow(modules, [4, 5]);
          mergeSourceModules(modules, [8, 9]);
          makeSourceRow(modules, [7, 8]);
          mergeSourceModules(modules, [10, 11]);
          makeSourceRow(modules, [10, 12], 'jamos-blog-article__source-row--tips');
          makeSourceRow(modules, [13], 'jamos-blog-article__source-row--callout');
          modules[16]?.classList.add('is-source-continuation');
          modules[20]?.classList.add('is-source-continuation');
          makeProductGrid(modules, [[14, 15, 16], [18, 19, 20]]);
          makeSourceRow(modules, [22, 23], 'jamos-blog-article__source-row--bundle');
        }

        if (articleNumber === '9') {
          modules[0]?.classList.add('is-source-continuation');
          mergeSourceModules(modules, [2, 4]);
          makeSourceRow(modules, [2, 3], 'jamos-blog-article__source-row--feature');
          mergeSourceModules(modules, [6, 7]);
          makeSourceRow(modules, [5, 6]);
          mergeSourceModules(modules, [9, 10]);
          makeSourceRow(modules, [8, 9]);
          mergeSourceModules(modules, [11, 12]);
          makeSourceRow(modules, [11, 13], 'jamos-blog-article__source-row--tips');
          makeSourceRow(modules, [14], 'jamos-blog-article__source-row--callout');
          modules[17]?.classList.add('is-source-continuation');
          modules[21]?.classList.add('is-source-continuation');
          makeProductGrid(modules, [[15, 16, 17], [19, 20, 21]]);
        }
      }

      if (article.closest('.jamos-learn-more--blog_article_10')) {
        const modules = article.querySelectorAll('.jamos-blog-article__module');
        const source = article.querySelector('.jamos-blog-article__source');
        source?.classList.add('is-source-layout-recognition');
        mergeSourceModules(modules, [2, 3]);
        mergeSourceModules(modules, [4, 5]);
        makeSourceRow(modules, [4, 6]);
        mergeSourceModules(modules, [8, 9]);
        makeSourceRow(modules, [7, 8], 'jamos-blog-article__source-row--reverse jamos-blog-article__source-row--feature');
        makeSourceRow(modules, [10, 11], 'jamos-blog-article__source-row--callout');
        makeSourceRow(modules, [12, 13]);
        modules[16]?.classList.add('is-source-continuation');
        modules[20]?.classList.add('is-source-continuation');
        const relatedContentPanel = makeProductGrid(modules, [[14, 15, 16], [18, 19, 20]]);
        relatedContentPanel?.classList.add('jamos-blog-article__source-product-grid--related-content');
        relatedContentPanel?.querySelectorAll('.jamos-blog-article__source-product').forEach((product) => {
          const imageModule = product.querySelector(':scope > .jamos-blog-article__module');
          const cta = product.querySelector('.jamos-blog-product-cta');
          if (!imageModule || !cta) return;
          cta.closest('p')?.remove();
          imageModule.appendChild(cta);
        });
      }
    });

    const sourceSlidePanels = Array.from(document.querySelectorAll('[data-jamos-source-slide]'));
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (sourceSlidePanels.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
      const sourceSlideObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const panel = entry.target;
          const image = panel.querySelector('img');
          if (!image) return;
          if (!entry.isIntersecting) {
            if (image.jamosSourceSlideAnimation) {
              image.jamosSourceSlideAnimation.cancel();
              image.jamosSourceSlideAnimation = null;
            }
            image.classList.remove('is-source-slide-active', 'is-source-slide-complete');
            image.classList.add('is-source-slide-ready');
            return;
          }

          if (image.classList.contains('is-source-slide-active')) return;
          image.classList.remove('is-source-slide-complete');
          requestAnimationFrame(() => {
            if (!image.isConnected || !image.classList.contains('is-source-slide-ready')) return;
            if (typeof image.animate === 'function') {
              image.jamosSourceSlideAnimation = image.animate([
                { opacity: 0, transform: 'scaleX(.5)' },
                { opacity: 1, transform: 'scaleX(1)' }
              ], {
                duration: 1000,
                delay: 300,
                easing: 'ease-in-out',
                fill: 'both'
              });
              image.jamosSourceSlideAnimation.onfinish = () => {
                image.classList.remove('is-source-slide-ready');
                image.classList.add('is-source-slide-complete');
                image.jamosSourceSlideAnimation = null;
              };
              return;
            }
            image.classList.add('is-source-slide-active');
            image.addEventListener('animationend', () => {
              image.classList.remove('is-source-slide-ready', 'is-source-slide-active');
              image.classList.add('is-source-slide-complete');
            }, { once: true });
          });
        });
      }, { threshold: .25 });

      sourceSlidePanels.forEach((panel) => {
        const image = panel.querySelector('img');
        if (!image) return;
        image.classList.add('is-source-slide-ready');
        sourceSlideObserver.observe(panel);
      });
    }

    const sourceFadePanels = Array.from(document.querySelectorAll('[data-jamos-source-fade]'));

    if (sourceFadePanels.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
      const sourceFadeObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const panel = entry.target;
          const image = panel.querySelector('img');
          if (!image) return;
          if (!entry.isIntersecting) {
            if (image.jamosSourceFadeAnimation) {
              image.jamosSourceFadeAnimation.cancel();
              image.jamosSourceFadeAnimation = null;
            }
            image.classList.remove('is-source-fade-active', 'is-source-fade-complete');
            image.classList.add('is-source-fade-ready');
            return;
          }

          if (image.classList.contains('is-source-fade-active')) return;
          image.classList.remove('is-source-fade-complete');
          requestAnimationFrame(() => {
            if (!image.isConnected || !image.classList.contains('is-source-fade-ready')) return;
            if (typeof image.animate === 'function') {
              image.jamosSourceFadeAnimation = image.animate([
                { opacity: 0 },
                { opacity: 1 }
              ], {
                duration: 1000,
                delay: 300,
                easing: 'ease-in-out',
                fill: 'both'
              });
              image.jamosSourceFadeAnimation.onfinish = () => {
                image.classList.remove('is-source-fade-ready');
                image.classList.add('is-source-fade-complete');
                image.jamosSourceFadeAnimation = null;
              };
              return;
            }
            image.classList.add('is-source-fade-active');
            image.addEventListener('animationend', () => {
              image.classList.remove('is-source-fade-ready', 'is-source-fade-active');
              image.classList.add('is-source-fade-complete');
            }, { once: true });
          });
        });
      }, { threshold: .25 });

      sourceFadePanels.forEach((panel) => {
        const image = panel.querySelector('img');
        if (!image) return;
        image.classList.add('is-source-fade-ready');
        sourceFadeObserver.observe(panel);
      });
    }

    const sourceTextPanels = Array.from(document.querySelectorAll('[data-jamos-source-text-reveal]'));

    if (sourceTextPanels.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
      const sourceTextObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const panel = entry.target;
          if (!entry.isIntersecting) {
            if (panel.jamosSourceTextAnimation) {
              panel.jamosSourceTextAnimation.cancel();
              panel.jamosSourceTextAnimation = null;
            }
            panel.classList.remove('is-source-text-active', 'is-source-text-complete');
            panel.classList.add('is-source-text-ready');
            return;
          }

          if (panel.classList.contains('is-source-text-active')) return;
          panel.classList.remove('is-source-text-complete');
          requestAnimationFrame(() => {
            if (!panel.isConnected || !panel.classList.contains('is-source-text-ready')) return;
            if (typeof panel.animate === 'function') {
              panel.jamosSourceTextAnimation = panel.animate([
                { opacity: 0, transform: 'translateY(.8rem)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], {
                duration: 1250,
                easing: 'ease-out',
                fill: 'both'
              });
              panel.jamosSourceTextAnimation.onfinish = () => {
                panel.classList.remove('is-source-text-ready');
                panel.classList.add('is-source-text-complete');
                panel.jamosSourceTextAnimation = null;
              };
              return;
            }
            panel.classList.add('is-source-text-active');
            panel.addEventListener('animationend', () => {
              panel.classList.remove('is-source-text-ready', 'is-source-text-active');
              panel.classList.add('is-source-text-complete');
            }, { once: true });
          });
        });
      }, { threshold: .25 });

      sourceTextPanels.forEach((panel) => {
        panel.classList.add('is-source-text-ready');
        sourceTextObserver.observe(panel);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamos-product-page"]) return;
  try {
    
  document.querySelectorAll('[data-jamos-pdp]').forEach((section) => {
    const mainImage = section.querySelector('.jamos-pdp__image');
    const thumbnails = section.querySelectorAll('[data-jamos-thumbnail]');
    const price = section.querySelector('[data-jamos-price]');
    const submit = section.querySelector('[data-jamos-submit]');
    const variants = section.querySelectorAll('[data-jamos-variant]');
    const quantity = section.querySelector('input[name="quantity"]');
    const decreaseQuantity = section.querySelector('[data-jamos-quantity-minus]');
    const increaseQuantity = section.querySelector('[data-jamos-quantity-plus]');
    const gallery = section.querySelector('.jamos-pdp__gallery');
    const thumbnailContainer = section.querySelector('.jamos-pdp__thumbs');
    const panels = section.querySelector('.jamos-pdp__media-details');
    const purchase = section.querySelector('.jamos-pdp__purchase');
    const mobileLayout = window.matchMedia('(max-width: 749px)');

    const relocatePanels = () => {
      if (!gallery || !panels || !purchase) return;

      if (mobileLayout.matches) {
        purchase.append(panels);
      } else {
        purchase.after(panels);
      }
    };

    relocatePanels();
    mobileLayout.addEventListener('change', relocatePanels);

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumbnail.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = thumbnail.dataset.imageAlt;
        thumbnails.forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      });
    });

    variants.forEach((variant) => {
      variant.addEventListener('change', () => {
        if (!variant.checked || !price || !submit) return;
        const available = variant.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
      });
    });

    const setQuantity = (amount) => {
      if (!quantity) return;
      quantity.value = Math.max(1, Number.parseInt(amount, 10) || 1);
    };

    decreaseQuantity?.addEventListener('click', () => setQuantity((Number.parseInt(quantity?.value, 10) || 1) - 1));
    increaseQuantity?.addEventListener('click', () => setQuantity((Number.parseInt(quantity?.value, 10) || 1) + 1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamos-recipes-index"]) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-jamos-recipes-scroll]').forEach((section) => {
      if (section.dataset.recipePhotosScrollInitialized === 'true' || reducedMotion) return;

      const photos = [...section.querySelectorAll('.jamos-recipes__image-wrap')];
      if (!photos.length) return;

      section.dataset.recipePhotosScrollInitialized = 'true';
      section.dataset.recipePhotosMotion = 'ready';

      if (!('IntersectionObserver' in window)) {
        photos.forEach((photo) => photo.classList.add('is-recipe-photo-revealed'));
        return;
      }

      const photoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.33) {
            entry.target.classList.add('is-recipe-photo-revealed');
            photoObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.33 });

      photos.forEach((photo) => photoObserver.observe(photo));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamos-recognition-page"]) return;
  try {
    
  (() => {
    const initializeMedalGlint = () => {
      const medal = document.querySelector('[data-jamos-recognition-medal]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!medal || medal.dataset.glintReady === 'true' || reducedMotion.matches) return;

      medal.dataset.glintReady = 'true';

      const scheduleGlint = () => {
        const delay = 3000 + Math.random() * 3000;

        window.setTimeout(() => {
          medal.classList.add('jamos-recognition__medal-tile--glinting');
        }, delay);
      };

      medal.addEventListener('animationend', (event) => {
        if (event.animationName !== 'jamos-recognition-medal-glint') return;

        medal.classList.remove('jamos-recognition__medal-tile--glinting');
        scheduleGlint();
      });

      scheduleGlint();
    };

    const initializeProductReveal = () => {
      const productsSection = document.querySelector('[data-jamos-recognition-products]');
      const productTiles = Array.from(document.querySelectorAll('[data-jamos-recognition-product]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!productsSection || !productTiles.length || reducedMotion.matches) return;

      productsSection.classList.add('jamos-recognition__products--reveal-ready');

      let hasRevealed = false;

      const revealProducts = () => {
        if (hasRevealed) return;

        const sectionBounds = productsSection.getBoundingClientRect();
        const sectionRevealPoint = sectionBounds.top + sectionBounds.height * .4;

        if (sectionRevealPoint > window.innerHeight) return;

        hasRevealed = true;
        window.removeEventListener('scroll', revealProducts);
        window.removeEventListener('resize', revealProducts);

        const randomizedTiles = [...productTiles];

        for (let index = randomizedTiles.length - 1; index > 0; index -= 1) {
          const randomizedIndex = Math.floor(Math.random() * (index + 1));
          [randomizedTiles[index], randomizedTiles[randomizedIndex]] = [randomizedTiles[randomizedIndex], randomizedTiles[index]];
        }

        randomizedTiles.forEach((tile, index) => {
          tile.style.setProperty('--jamos-recognition-reveal-delay', `${index * 132}ms`);
        });

        window.setTimeout(() => {
          productsSection.classList.add('jamos-recognition__products--reveal-visible');
        }, 1000);
      };

      window.addEventListener('scroll', revealProducts, { passive: true });
      window.addEventListener('resize', revealProducts);
      revealProducts();
    };

    const initializeAwardImageReveal = () => {
      const awardImage = document.querySelector('[data-jamos-recognition-award-image]');
      const storyHeading = document.querySelector('[data-jamos-recognition-story-heading]');
      const storyCopy = document.querySelector('[data-jamos-recognition-story-copy]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!awardImage || !storyHeading || !storyCopy || reducedMotion.matches) return;

      awardImage.classList.add('jamos-recognition__award-image--reveal-ready');
      storyHeading.classList.add('jamos-recognition__story-heading--reveal-ready');
      storyCopy.classList.add('jamos-recognition__story-copy--reveal-ready');

      let hasRevealed = false;

      const revealAwardImage = () => {
        if (hasRevealed) return;

        const imageBounds = awardImage.getBoundingClientRect();
        const imageRevealPoint = imageBounds.top + imageBounds.height * .3;

        if (imageRevealPoint > window.innerHeight) return;

        hasRevealed = true;
        window.removeEventListener('scroll', revealAwardImage);
        window.removeEventListener('resize', revealAwardImage);

        window.requestAnimationFrame(() => {
          awardImage.classList.add('jamos-recognition__award-image--reveal-visible');
          storyHeading.classList.add('jamos-recognition__story-heading--reveal-visible');
          window.setTimeout(() => {
            storyCopy.classList.add('jamos-recognition__story-copy--reveal-visible');
          }, 1100);
        });
      };

      window.addEventListener('scroll', revealAwardImage, { passive: true });
      window.addEventListener('resize', revealAwardImage);
      revealAwardImage();
    };

    const initializeProductsHeadingReveal = () => {
      const productsHeading = document.querySelector('[data-jamos-recognition-products-heading]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!productsHeading || reducedMotion.matches) return;

      productsHeading.classList.add('jamos-recognition__products-heading--reveal-ready');

      let hasRevealed = false;

      const revealProductsHeading = () => {
        if (hasRevealed) return;

        const headingBounds = productsHeading.getBoundingClientRect();
        const headingRevealPoint = headingBounds.top + headingBounds.height * .45;

        if (headingRevealPoint > window.innerHeight) return;

        hasRevealed = true;
        window.removeEventListener('scroll', revealProductsHeading);
        window.removeEventListener('resize', revealProductsHeading);

        window.requestAnimationFrame(() => {
          productsHeading.classList.add('jamos-recognition__products-heading--reveal-visible');
        });
      };

      window.addEventListener('scroll', revealProductsHeading, { passive: true });
      window.addEventListener('resize', revealProductsHeading);
      revealProductsHeading();
    };

    const initializeResultsReveal = () => {
      const results = document.querySelector('[data-jamos-recognition-results]');
      const leftTile = document.querySelector('[data-jamos-recognition-results-left]');
      const honorTile = document.querySelector('[data-jamos-recognition-results-honor]');
      const rightTile = document.querySelector('[data-jamos-recognition-results-right]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!results || !leftTile || !honorTile || !rightTile || reducedMotion.matches || results.dataset.revealReady === 'true') return;

      results.dataset.revealReady = 'true';
      results.classList.add('jamos-recognition__results--reveal-ready');

      const lineStagger = 140;
      const lineDuration = 600;
      const tileDelay = 350;
      const summaryDuration = lineDuration + (leftTile.children.length - 1) * lineStagger;

      [leftTile, rightTile].forEach((tile) => {
        Array.from(tile.children).forEach((line, index) => {
          line.style.setProperty('--jamos-recognition-results-line-delay', `${index * lineStagger}ms`);
        });
      });

      let hasRevealed = false;

      const revealResults = () => {
        if (hasRevealed) return;

        const resultsBounds = results.getBoundingClientRect();
        const resultsRevealPoint = resultsBounds.top + resultsBounds.height * .6;

        if (resultsRevealPoint > window.innerHeight) return;

        hasRevealed = true;
        window.removeEventListener('scroll', revealResults);
        window.removeEventListener('resize', revealResults);

        window.requestAnimationFrame(() => {
          leftTile.classList.add('jamos-recognition__results-summary--reveal-visible');
          window.setTimeout(() => {
            rightTile.classList.add('jamos-recognition__results-summary--reveal-visible');
          }, summaryDuration + tileDelay);
          window.setTimeout(() => {
            honorTile.classList.add('jamos-recognition__results-honor--reveal-visible');
          }, summaryDuration * 2 + tileDelay * 2);
        });
      };

      window.addEventListener('scroll', revealResults, { passive: true });
      window.addEventListener('resize', revealResults);
      revealResults();
    };

    const initializeQuoteTyping = () => {
      const quote = document.querySelector('[data-jamos-recognition-quote]');
      const quoteCopy = document.querySelector('[data-jamos-recognition-quote-copy]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!quote || !quoteCopy || reducedMotion.matches) return;

      const fullQuote = quoteCopy.textContent.trim();
      const quoteCharacters = Array.from(fullQuote, (character) => {
        const characterElement = document.createElement('span');

        characterElement.className = 'jamos-recognition__quote-character';
        characterElement.textContent = character;

        return characterElement;
      });

      quoteCopy.replaceChildren(...quoteCharacters);
      quote.classList.add('jamos-recognition__quote--typing-ready');
      quote.classList.add('jamos-recognition__quote--intro-ready');

      let hasTyped = false;

      const typeQuote = () => {
        let characterIndex = 0;

        quote.classList.add('jamos-recognition__quote--typing');

        const typeNextCharacter = () => {
          if (characterIndex > 0) {
            quoteCharacters[characterIndex - 1].classList.remove('jamos-recognition__quote-character--current');
          }

          quoteCharacters[characterIndex].classList.add('jamos-recognition__quote-character--visible', 'jamos-recognition__quote-character--current');
          characterIndex += 1;

          if (characterIndex < fullQuote.length) {
            window.setTimeout(typeNextCharacter, 55.8);
          } else {
            quote.classList.remove('jamos-recognition__quote--typing');
            quote.classList.add('jamos-recognition__quote--typing-complete');
          }
        };

        typeNextCharacter();
      };

      const revealQuote = () => {
        if (hasTyped) return;

        const quoteBounds = quote.getBoundingClientRect();
        const quoteRevealPoint = quoteBounds.top + quoteBounds.height * .5;

        if (quoteRevealPoint > window.innerHeight) return;

        hasTyped = true;
        window.removeEventListener('scroll', revealQuote);
        window.removeEventListener('resize', revealQuote);
        window.requestAnimationFrame(() => {
          quote.classList.add('jamos-recognition__quote--intro-visible');
          window.setTimeout(typeQuote, 1300);
        });
      };

      window.addEventListener('scroll', revealQuote, { passive: true });
      window.addEventListener('resize', revealQuote);
      revealQuote();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeMedalGlint, { once: true });
      document.addEventListener('DOMContentLoaded', initializeProductReveal, { once: true });
      document.addEventListener('DOMContentLoaded', initializeAwardImageReveal, { once: true });
      document.addEventListener('DOMContentLoaded', initializeProductsHeadingReveal, { once: true });
      document.addEventListener('DOMContentLoaded', initializeResultsReveal, { once: true });
      document.addEventListener('DOMContentLoaded', initializeQuoteTyping, { once: true });
    } else {
      initializeMedalGlint();
      initializeProductReveal();
      initializeAwardImageReveal();
      initializeProductsHeadingReveal();
      initializeResultsReveal();
      initializeQuoteTyping();
    }

    document.addEventListener('shopify:section:load', initializeMedalGlint);
    document.addEventListener('shopify:section:load', initializeProductReveal);
    document.addEventListener('shopify:section:load', initializeAwardImageReveal);
    document.addEventListener('shopify:section:load', initializeProductsHeadingReveal);
    document.addEventListener('shopify:section:load', initializeResultsReveal);
    document.addEventListener('shopify:section:load', initializeQuoteTyping);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okt10-ofest-shop"]) return;
  try {
    
document.addEventListener('change', (event) => {
 if(event.target.id !== 'ofest-variant') return;
 const option=event.target.selectedOptions[0], root=event.target.closest('.ofest-shop');
 root.querySelector('[data-ofest-price]').firstChild.textContent=option.dataset.price+' ';
 root.querySelector('[data-ofest-submit]').disabled=option.dataset.available !== 'true';
 root.querySelector('[data-ofest-stock]').textContent=option.dataset.available === 'true' ? root.dataset.availableText : root.dataset.soldText;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantSelector = section.querySelector('[data-product-variant]');
    const variantOptions = section.querySelectorAll('[data-product-variant-option]');
    const price = section.querySelector('[data-product-price]');
    const submit = section.querySelector('[data-product-submit]');
    const mainImage = section.querySelector('.jamos-product__main-image');
    const mainMedia = section.querySelector('.jamos-product__main-media');
    const thumbnails = section.querySelectorAll('[data-product-thumbnail]');
    const media = section.querySelector('.jamos-product__media');
    const thumbnailContainer = section.querySelector('.jamos-product__thumbnails');
    const details = section.querySelector('.jamos-product__details');
    const content = section.querySelector('.jamos-product__content');
    const mobileLayout = window.matchMedia('(max-width: 749px)');

    const relocateDetails = () => {
      if (!details || !media || !content) return;

      if (mobileLayout.matches) {
        content.append(details);
      } else {
        content.after(details);
      }
    };

    relocateDetails();
    mobileLayout.addEventListener('change', relocateDetails);

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;

        mainImage.src = thumbnail.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = thumbnail.dataset.imageAlt;

        thumbnails.forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      });
    });

    if (mainImage && mainMedia) {
      mainMedia.addEventListener('mousemove', (event) => {
        const bounds = mainMedia.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width) * 100;
        const y = ((event.clientY - bounds.top) / bounds.height) * 100;

        mainImage.style.transformOrigin = `${x}% ${y}%`;
      });

      mainMedia.addEventListener('mouseleave', () => {
        mainImage.style.transformOrigin = 'center';
      });
    }

    if ((!variantSelector && variantOptions.length === 0) || !price || !submit) return;

    const updateVariant = (selectedOption) => {
      const isAvailable = selectedOption.dataset.available === 'true';

      submit.disabled = !isAvailable;
      submit.textContent = isAvailable ? section.dataset.addToCartLabel : section.dataset.soldOutLabel;
    };

    if (variantSelector) {
      variantSelector.addEventListener('change', () => {
        updateVariant(variantSelector.options[variantSelector.selectedIndex]);
      });
    }

    variantOptions.forEach((variantOption) => {
      variantOption.addEventListener('change', () => updateVariant(variantOption));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
